import { Injectable } from '@angular/core';
import { databases, ID, storage } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { EspecialistaTarifa } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EspecialistaTarifaService {

  private collectionId = "especialistas_tarifas";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }

   /**
   * @getData()
   * @returns
   */
   getData(): Promise<EspecialistaTarifa[]> {
    return databases.listDocuments<EspecialistaTarifa>(
      this.DATABASE_NAME,
      this.collectionId
    ).then(response => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: EspecialistaTarifa) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }


  /**
   * @updateDocument()
   * @param idDocument
   * @param data
   * @returns
   */
  updateDocument(idDocument: string, data: EspecialistaTarifa) {
    data.$databaseId = '';
    data.$collectionId = '';
    return databases.updateDocument(this.DATABASE_NAME, this.collectionId, idDocument, data);
  }

  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDocuments(idEspecialista: string): Promise<EspecialistaTarifa[]> {
    return databases.listDocuments<EspecialistaTarifa>(
      this.DATABASE_NAME,
      this.collectionId,
      [
        Query.equal('idEspecialista', [idEspecialista]),
      Query.equal('estado', true)]
    ).then(response => response.documents);
  }
  
  algoAqui(): Promise<any> {

 

    return databases.listDocuments<any>(
      this.DATABASE_NAME,
      this.collectionId,
      [
      // Query.select(["VrServicio","fDesde","fHasta","servicioId"]),    
      Query.equal('idEspecialista', ["6646036d643c5195a294"])
    ]
    )

    // return databases.listDocuments<any>(
    //   this.DATABASE_NAME,
    //   this.collectionId,
    //   [
    //     Query.select(['nombre','$id','descripcion',"foto","perfil.especialidad","valoracion"]),
    //     Query.orderDesc("valoracion"),
    //     Query.equal('activo', true)
    //   ],



  }


  /**
   * @deleteDocument()
   * @param fileId
   * @returns
   */
  deleteDocument(documentId: string) {
    return databases.deleteDocument(this.DATABASE_NAME, this.collectionId, documentId);
  }
}
